import { forwardRef } from 'react'

import { cn } from '@/utils/tw-helpers'

export interface PillRadioProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  children: React.ReactNode
}

export const PillRadio = forwardRef<HTMLInputElement, PillRadioProps>(
  ({ children, className, id, ...rest }, ref) => {
    return (
      <label
        htmlFor={id}
        className={cn(
          'border-border/20 inline-flex h-[47px] cursor-pointer items-center rounded-xl border-2 bg-white px-4 py-2 text-sm font-medium text-secondary-20 transition-colors',
          'has-[:checked]:border-primary-70 has-[:checked]:bg-primary-95 has-[:checked]:text-primary-50',
          className
        )}
      >
        <input ref={ref} type="radio" id={id} className="sr-only" {...rest} />
        {children}
      </label>
    )
  }
)

PillRadio.displayName = 'PillRadio'
